export function intercomTargetProps(targetName?: string) {
    if (targetName != null) {
        return {'data-intercom-target': targetName};
    }
}
